import { TPL_COVERS_NEW } from './../Models/TPL_COVERS_NEW';
import {Injectable, Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'tplManCovers',
  pure:false
})
@Injectable()
export class tplManCovers implements PipeTransform {
  transform(tplCovers: Array<TPL_COVERS_NEW>, sel:boolean): any {
    return tplCovers.filter(t => t.IsMandatory==sel);
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pipes/tplManCovers.ts